module.exports = __webpack_public_path__ + "img/armasuisse.890a2e1b.jpg";